module.exports = __webpack_public_path__ + "img/linkedin.fb09ae96.png";